import { connect } from 'react-redux';
import { setFavorite, unsetFavorite } from '../../actions/favorites';
import EllipsisDropdown from './EllipsisDropdown';

const mapState = state => {
  const { favorites } = state;
  const { keys } = favorites;
  return {
    favoritesKeys: keys,
  };
};

const mapDispatch = {
  setFavorite,
  unsetFavorite,
};

export default connect(mapState, mapDispatch)(EllipsisDropdown);
